export default __webpack_public_path__ + "static/media/step2Img.217255a4.svg";